module.exports = __webpack_public_path__ + "img/growth.24d351f5.jpg";